import { render } from "./logoHorizontal.svg?vue&type=template&id=50282874"
const script = {}
script.render = render

export default script